// @flow

import React from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { Button, Col, SchemaTable, Icons } from "@components";
import type { ReferralReason } from "@modules/service/reducer/referrals/types";

type OwnProps = $Exact<{
  data: Array<ReferralReason>,
  schema: Object,
  onChange: (data: Array<ReferralReason>) => void | boolean,
  disabled?: boolean,
  addItemButtonText?: string,
  title?: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class CommonReasonInputForm extends React.Component<Props> {
  get titleField() {
    return this.props.titleField || "reason";
  }

  get defaultReasons() {
    return [
      {
        id: null,
        [this.titleField]: "",
        isActive: true,
      },
    ];
  }

  get data() {
    return this.props.data && this.props.data.length ? this.props.data : this.defaultReasons;
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": [this.titleField, "isActive"],
      [this.titleField]: {
        "ui:title": this.props.t("REASON"),
        "ui:widget": "text",
        "ui:options": {
          disabled: (item: Object) => !item.isActive,
          required: true,
          editable: true,
          minWidth: "85%",
        },
      },
      isActive: {
        "ui:title": this.props.t("STATUS"),
        "ui:widget": "switch",
        "ui:options": {
          editable: true,
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange([...this.data, ...this.defaultReasons]);
  };

  handleChange = (data: Array<ReferralReason>) => {
    this.props.onChange([...data]);
  };

  render() {
    return (
      <React.Fragment>
        {this.props.disabled ? null : (
          <div
            className={classNames("d-flex row justify-content-end pl-4 pr-4", {
              "justify-content-between": this.props.title,
            })}
          >
            {this.props.title && <h6>{this.props.t(this.props.title)}</h6>}
            <Button
              materialIcon="add_circle"
              className="link eap-rsu__add-button"
              onClick={this.handleAdd}
            >
              {this.props.addItemButtonText || this.props.t("ADD")}
            </Button>
          </div>
        )}
        {this.schema && this.uiSchema ? (
          <SchemaTable
            tableData={this.data}
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={this.handleChange}
            disabled={!!this.props.disabled}
            allowDeletes
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default localize()(CommonReasonInputForm);
